import { useState } from "react";
import { useAuth, apiError } from "@/context/AuthContext";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

// Troca de senha OBRIGATÓRIA no primeiro acesso (contas criadas com senha provisória).
// Modal não dispensável enquanto must_change_password for verdadeiro.
export function ForcePasswordChange() {
  const { user, setUser } = useAuth();
  const [atual, setAtual] = useState("");
  const [nova, setNova] = useState("");
  const [saving, setSaving] = useState(false);
  if (!user || !user.must_change_password) return null;

  const salvar = async () => {
    setSaving(true);
    try {
      await api.post("/auth/change-password", { senha_atual: atual, nova_senha: nova });
      const { data } = await api.get("/auth/me");
      setUser(data);
      toast.success("Senha atualizada. Acesso liberado.");
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="bg-popover border-border" data-testid="force-password-dialog">
        <DialogHeader>
          <DialogTitle>Defina uma nova senha</DialogTitle>
          <DialogDescription>Por segurança, é necessário substituir a senha provisória no primeiro acesso.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Senha provisória (atual)</Label><Input data-testid="fp-atual" type="password" value={atual} onChange={(e) => setAtual(e.target.value)} /></div>
          <div><Label>Nova senha</Label><Input data-testid="fp-nova" type="password" value={nova} onChange={(e) => setNova(e.target.value)} placeholder="Mínimo 4 caracteres" /></div>
        </div>
        <DialogFooter>
          <Button data-testid="fp-salvar" onClick={salvar} disabled={saving || !atual || nova.length < 4}>Salvar nova senha</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
